import React from "react"

const DetailListText = ({ children, length = 0, index = 0 }) => {
  const style = {
    color: "#2f87d0",
    fontSize: "1.5rem",
  }

  return (
    <>
      <span style={style}>{children}</span>
      {length > 1 && index < length - 1 ? (
        <span style={{ marginRight: 4, color: style.color }}>,</span>
      ) : null}
    </>
  )
}

export default DetailListText
